<div class="header_container ">
  <div class="topbar ">
    <div class="logo">
      <a [routerLink]="['/dashboard']">
        <img src="assets/images/logo.png" />
      </a>
    </div>
    <div class="topbar_right">
      <button *ngIf="hasPermission('support-panel')" type="button" class="sp-open-btn" [disabled]="openingSupportPanel"
        (click)="openSupportPanel()" title="Open the Support Panel, already signed in">
        <i [ngClass]="openingSupportPanel ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-headset'"></i>
        <span>Support Panel</span>
      </button>
      <button [routerLink]="['/qr-code']" class="qr-btn" title="QR Code">
        <i class="fa-solid fa-qrcode"></i>
      </button>
      <!-- <button *ngIf="hasPermission('emergency-notification')" title="Emergency Notification" type="button" [routerLink]="['/emergency-notification']"
        class="emergency-btn">
        <i class="fa fa-exclamation-triangle"></i>
      </button> -->
      <div class="topbar_divider"></div>
      <div class="topbar_profile">
        <button (click)="logout()" class="avatar_btn" title="Logout"><img src="assets/images/user.png" /></button>
        <div class="topbar_name">Hi, {{ displayName }}</div>
      </div>
    </div>
  </div>
  <ul class="menuH_container ">
    <li *ngIf="hasPermission('dashboard')">
      <a [routerLink]="['/dashboard']" [ngClass]="{'active':router.url=='/dashboard'}" class="menu-item"><b>
          <span class="menu_black"><i class="fa fa-tachometer" aria-hidden="true"></i>
          </span>
          <span class="menu_white"><i class="fa fa-tachometer" aria-hidden="true"></i>
          </span></b>
        <span>Dashboard</span>
      </a>
    </li>
    <li *ngIf="hasPermission('apartment') || hasPermission('hotel-apartment') || hasPermission('residential-apartment') || hasPermission('owner')"
        class="notification-dropdown">
      <a href="javascript:void(0)" (click)="toggleApartmentDropdown()" [ngClass]="{ active: ApartmentUrl() }" class="menu-item">
        <b>
          <img src="assets/images/apartment.svg" class="menu_black" />
          <img src="assets/images/apartment1.svg" class="menu_white" />
        </b>
        <span class="notify-text">
          Apartment
          <i class="fa-solid fa-chevron-down notify-arrow" [class.rotate]="isApartmentDropdownOpen()"></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="isApartmentDropdownOpen()">
        <li *ngIf="hasPermission('apartment') || hasPermission('hotel-apartment')">
          <a [routerLink]="['/apartment']" [ngClass]="{ active: HotelApartmentUrl() }">
            <b>
              <img src="assets/images/apartment.svg" class="menu_black" />
              <img src="assets/images/apartment1.svg" class="menu_white" />
            </b>
            <span>Hotel Apartments</span>
          </a>
        </li>
        <li *ngIf="hasPermission('apartment') || hasPermission('residential-apartment')">
          <a [routerLink]="['/apartment/residential-apartment']" [ngClass]="{ active: ResidentialApartmentUrl() }">
            <b>
              <img src="assets/images/apartment.svg" class="menu_black" />
              <img src="assets/images/apartment1.svg" class="menu_white" />
            </b>
            <span>Residential Apartments</span>
          </a>
        </li>
        <li *ngIf="hasPermission('apartment') || hasPermission('owner')">
          <a [routerLink]="['/owner']" [ngClass]="{ active: OwnerUrl() }">
            <b>
              <img src="assets/images/apartment.svg" class="menu_black" />
              <img src="assets/images/apartment1.svg" class="menu_white" />
            </b>
            <span>Owners</span>
          </a>
        </li>
        <li *ngIf="hasPermission('apartment') || hasPermission('hotel-apartment') || hasPermission('residential-apartment')">
          <a [routerLink]="['/admin-logs']" [ngClass]="{ active: AdminLogsUrl() }">
            <b>
              <img src="assets/images/apartment.svg" class="menu_black" />
              <img src="assets/images/apartment1.svg" class="menu_white" />
            </b>
            <span>Admin Logs</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="hasPermission('laundry') || hasPermission('restaurant') || hasPermission('grocery') || hasPermission('club') || hasPermission('spa') || hasPermission('car-rental') || hasPermission('adventure')"
        class="notification-dropdown">

      <a href="javascript:void(0)" (click)="toggleVendorsDropdown()" [ngClass]="{'active': VendorsUrl()}" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa-solid fa-store"></i></span>
          <span class="menu_white"><i class="fa-solid fa-store"></i></span>
        </b>
        <span class="notify-text">
          Hub
          <i class="fa-solid fa-chevron-down notify-arrow" [class.rotate]="isVendorsDropdownOpen()"></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="isVendorsDropdownOpen()">
        <li *ngIf="hasPermission('laundry')">
          <a [routerLink]="['/laundry']" [ngClass]="{ active: LaundryUrl() }">
            <b>
              <img src="assets/images/laundry_logo2.svg" class="menu_black" />
              <img src="assets/images/laundry_logo1.svg" class="menu_white" />
            </b>
            <span>Laundry</span>
          </a>
        </li>
        <li *ngIf="hasPermission('restaurant')">
          <a [routerLink]="['/restaurant']" [ngClass]="{ active: RestuarantUrl() }">
            <b>
              <img src="../../../assets/images/restuarant.svg" class="menu_black" />
              <img src="../../../assets/images/restuarant1.svg" class="menu_white" />
            </b>
            <span>Restaurant</span>
          </a>
        </li>
        <li *ngIf="hasPermission('grocery')">
          <a [routerLink]="['/grocery']" [ngClass]="{ active: GroceryUrl() }">
            <b>
              <img src="../../../assets/images/restuarant.svg" class="menu_black" />
              <img src="../../../assets/images/restuarant1.svg" class="menu_white" />
            </b>
            <span>Grocery</span>
          </a>
        </li>
        <li *ngIf="hasPermission('club')">
          <a [routerLink]="['/club']" [ngClass]="{ active: clubUrl() }">
            <b>
              <img src="../../../assets/images/flags.png" class="menu_black" />
              <img src="../../../assets/images/flags1.png" class="menu_white" />
            </b>
            <span>Club</span>
          </a>
        </li>
        <li *ngIf="hasPermission('spa')">
          <a [routerLink]="['/spa']" [ngClass]="{ active: spaUrl() }">
            <b>
              <img src="../../../assets/images/spa1.svg" class="menu_black" />
              <img src="../../../assets/images/spa2.svg" class="menu_white" />
            </b>
            <span>Spa & Salon</span>
          </a>
        </li>
        <li *ngIf="hasPermission('car-rental')">
          <a [routerLink]="['/car-rental']" [ngClass]="{ active: carRentalUrl() }">
            <b>
              <img src="../../../assets/images/restuarant.svg" class="menu_black" />
              <img src="../../../assets/images/restuarant1.svg" class="menu_white" />
            </b>
            <span>Car Rental</span>
          </a>
        </li>
        <li *ngIf="hasPermission('adventure')">
          <a [routerLink]="['/adventure']" [ngClass]="{ active: adventureUrl() }">
            <b>
              <img src="../../../assets/images/restuarant.svg" class="menu_black" />
              <img src="../../../assets/images/restuarant1.svg" class="menu_white" />
            </b>
            <span>Adventure</span>
          </a>
        </li>
      </ul>
    </li>

    <li *ngIf="hasPermission('onboarding')">
      <a [routerLink]="['/onboarding']" [ngClass]="{ active: router.url.includes('/onboarding') }"><b>
          <span class="menu_black"><i class="fa-solid fa-inbox"></i></span>
          <span class="menu_white"><i class="fa-solid fa-inbox"></i></span></b>
        <span>Onboarding</span>
      </a>
    </li>

    <li *ngIf="hasPermission('upload-banner') || hasPermission('notification') || hasPermission('FAQ-category') || hasPermission('feedback') || hasPermission('ratings') || hasPermission('coupon')"
        class="notification-dropdown">

      <a href="javascript:void(0)" (click)="toggleMarketingDropdown()" [ngClass]="{'active': MarketingUrl()}" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa-solid fa-bullhorn"></i></span>
          <span class="menu_white"><i class="fa-solid fa-bullhorn"></i></span>
        </b>
        <span class="notify-text">
          Spotlight
          <i class="fa-solid fa-chevron-down notify-arrow" [class.rotate]="isMarketingDropdownOpen()"></i>
        </span>
      </a>

      <ul class="notify-menu" *ngIf="isMarketingDropdownOpen()">
        <li *ngIf="hasPermission('upload-banner')">
          <a [routerLink]="['/upload-banner']" [ngClass]="{ active: UploadBannerUrl() }">
            <b>
              <img src="assets/images/advertise1.svg" class="menu_black" />
              <img src="assets/images/advertise2.svg" class="menu_white" />
            </b>
            <span>Banner Image</span>
          </a>
        </li>
          <li *ngIf="hasPermission('FAQ-category') || hasPermission('feedback')">
      <a [routerLink]="['/FAQ-category']" [ngClass]="{ active: FAQUrl() }">
        <b>
          <span class="menu_black"><i class="fa fa-commenting" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-commenting" aria-hidden="true"></i></span>
        </b>
        <span>FAQ</span>
      </a>
    </li>
        <li *ngIf="hasPermission('ratings')">
          <a [routerLink]="['/ratings']" [ngClass]="{'active': router.url === '/ratings'}">
            <b>
              <span class="menu_black"><i class="fa-solid fa-star"></i></span>
              <span class="menu_white"><i class="fa-solid fa-star"></i></span>
            </b>
            <span>Reviews & Ratings</span>
          </a>
        </li>
        <li *ngIf="hasPermission('notification')">
          <a [routerLink]="['/notification']" [ngClass]="{'active': router.url === '/notification'}">
            <b>
              <span class="menu_black"><i class="fa-solid fa-bell"></i></span>
              <span class="menu_white"><i class="fa-solid fa-bell"></i></span>
            </b>
            <span>Pop-up notification</span>
          </a>
        </li>
        <li *ngIf="hasPermission('coupon')">
          <a [routerLink]="['/coupon']" [ngClass]="{'active': router.url.includes('coupon')}">
            <b>
              <span class="menu_black"><i class="fa fa-ticket" aria-hidden="true"></i></span>
              <span class="menu_white"><i class="fa fa-ticket" aria-hidden="true"></i></span>
            </b>
            <span>Coupon</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="hasPermission('emergency-notification')"
        class="notification-dropdown">
      <a href="javascript:void(0)" (click)="toggleEmergencyDropdown()" [ngClass]="{'active': emgNotification()}" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa-solid fa-triangle-exclamation"></i></span>
          <span class="menu_white"><i class="fa-solid fa-triangle-exclamation"></i></span>
        </b>
        <span class="notify-text">
          Emergency
          <i class="fa-solid fa-chevron-down notify-arrow" [class.rotate]="isEmergencyDropdownOpen()"></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="isEmergencyDropdownOpen()">
        <li>
          <a [routerLink]="['/emergency-notification']" [ngClass]="{ active: router.url === '/emergency-notification' }">
            <b>
              <span class="menu_black"><i class="fa-regular fa-file-lines"></i></span>
              <span class="menu_white"><i class="fa-regular fa-file-lines"></i></span>
            </b>
            <span>Alert Template</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/floor-mapping']" [ngClass]="{ active: router.url === '/floor-mapping' }">
            <b>
              <span class="menu_black"><i class="fa-solid fa-layer-group"></i></span>
              <span class="menu_white"><i class="fa-solid fa-layer-group"></i></span>
            </b>
            <span>Floor Mapping</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/active-alert']" [ngClass]="{ active: router.url === '/active-alert' }">
            <b>
              <span class="menu_black"><i class="fa-solid fa-bell"></i></span>
              <span class="menu_white"><i class="fa-solid fa-bell"></i></span>
            </b>
            <span>Active Alert</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/alert-history']" [ngClass]="{ active: router.url === '/alert-history' || router.url.startsWith('/alert-response') }">
            <b>
              <span class="menu_black"><i class="fa fa-history"></i></span>
              <span class="menu_white"><i class="fa fa-history"></i></span>
            </b>
            <span>Alert History</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="hasPermission('setting') || hasPermission('audit-logs') || hasPermission('tax') || hasPermission('support-panel') || hasPermission('translations')"
        class="notification-dropdown">
      <a href="javascript:void(0)" (click)="toggleSettingsDropdown()" [ngClass]="{'active': SettingsUrl()}" class="menu-item">
        <b>
          <span class="menu_black"><i class="fa fa-cog" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-cog" aria-hidden="true"></i></span>
        </b>
        <span class="notify-text">
          Settings
          <i class="fa-solid fa-chevron-down notify-arrow" [class.rotate]="isSettingsDropdownOpen()"></i>
        </span>
      </a>
      <ul class="notify-menu" *ngIf="isSettingsDropdownOpen()">
        <li *ngIf="hasPermission('setting')">
          <a [routerLink]="['/setting']" [ngClass]="{'active': settingUrl()}">
            <b>
              <span class="menu_black"><i class="fa fa-cog" aria-hidden="true"></i></span>
              <span class="menu_white"><i class="fa fa-cog" aria-hidden="true"></i></span>
            </b>
            <span>Settings</span>
          </a>
        </li>
        <li *ngIf="hasPermission('tax')">
          <a [routerLink]="['/tax']" [ngClass]="{'active': taxUrl()}">
            <b>
              <span class="menu_black"><i class="fas fa-sack-dollar"></i></span>
              <span class="menu_white"><i class="fas fa-sack-dollar"></i></span>
            </b>
            <span>Vat</span>
          </a>
        </li>
        <li *ngIf="hasPermission('audit-logs')">
          <a [routerLink]="['/audit-logs']" [ngClass]="{'active': auditLogsUrl()}">
            <b>
              <span class="menu_black"><i class="fa fa-shield" aria-hidden="true"></i></span>
              <span class="menu_white"><i class="fa fa-shield" aria-hidden="true"></i></span>
            </b>
            <span>Audit Logs</span>
          </a>
        </li>
        <li *ngIf="hasPermission('support-panel')">
          <a [routerLink]="['/support-panel']" [ngClass]="{'active': router.url.includes('support-panel')}">
            <b>
              <span class="menu_black"><i class="fa fa-headphones" aria-hidden="true"></i></span>
              <span class="menu_white"><i class="fa fa-headphones" aria-hidden="true"></i></span>
            </b>
            <span>Support Panel</span>
          </a>
        </li>
        <li *ngIf="hasPermission('translations')">
          <a [routerLink]="['/translations']" [ngClass]="{'active': router.url.includes('translations')}">
            <b>
              <span class="menu_black"><i class="fa fa-language" aria-hidden="true"></i></span>
              <span class="menu_white"><i class="fa fa-language" aria-hidden="true"></i></span>
            </b>
            <span>Translations</span>
          </a>
        </li>
      </ul>
    </li>

    <li
      *ngIf="hasPermission('all-orders') || hasPermission('order-detail') || hasPermission('room-order-details') || hasPermission('food-order-details') || hasPermission('additional-order-details') || hasPermission('bill-to-desk') || hasPermission('residential-order-details') || hasPermission('club-order-details') || hasPermission('car-rental-order-details') || hasPermission('grocery-order-details')">
      <a [routerLink]="['/all-orders']" [ngClass]="{ active: OrderUrl() }"><b>
          <img src="assets/images/apartment.svg" class="menu_black" />
          <img src="assets/images/apartment1.svg" class="menu_white" /></b>
        <span>Order Details</span>
      </a>
    </li>
    <li *ngIf="isGlobalAdmin">
      <a [routerLink]="['/staff']" [ngClass]="{ active: staffUrl() }"><b>
          <img src="assets/images/customer1.svg" style="width: 100%" class="menu_black" />
          <img src="assets/images/customer2.svg" style="width: 100%" class="menu_white" />
        </b><span>Staff &amp; Role</span>
      </a>
    </li>
    <li
      *ngIf="hasPermission('room-service-report') || hasPermission('laundry-report') || hasPermission('restaurant-report') || hasPermission('residential-report') || hasPermission('club-report')">
      <a [routerLink]="['/room-service-report']" [ngClass]="{ active: ReportUrl() }" class="menu-item"><b>
          <span class="menu_black"><i class="fa fa-file-text" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-file-text" aria-hidden="true"></i></span>
        </b><span>Report</span>
      </a>
    </li>
    <li
      *ngIf="hasPermission('wallet')">
      <a [routerLink]="['/wallet']" [ngClass]="{ active: WalletUrl() }"  class="menu-item"><b>
          <span class="menu_black"><i class="fa fa-wallet" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-wallet" aria-hidden="true"></i></span>
        </b><span>Wallet</span>
      </a>
    </li>
    <li *ngIf="hasPermission('user-alerts')">
      <a [routerLink]="['/user-alerts']" [ngClass]="{ active: userAlertsUrl() }" class="menu-item"><b>
          <span class="menu_black"><i class="fa fa-bell" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-bell" aria-hidden="true"></i></span>
        </b><span>User Alerts</span>
      </a>
    </li>
    <li *ngIf="hasPermission('vendor-settlement')">
      <a [routerLink]="['/vendor-settlement']" [ngClass]="{ active: vendorSettlementUrl() }" class="menu-item"><b>
          <span class="menu_black"><i class="fa fa-receipt" aria-hidden="true"></i></span>
          <span class="menu_white"><i class="fa fa-receipt" aria-hidden="true"></i></span>
        </b><span>Settlement</span>
      </a>
    </li>
  </ul>
</div>